import { createZodDto } from 'nestjs-zod/dto';
import { z } from 'zod';
import { dateParser } from '#validation';
import { ssoEnforcementTypeParser, ssoExternalUserEnforcementParser, } from '#validation/sso/parsers';
export const SsoConfigResponseSchema = z.object({
    id: z.string(),
    idpEntityId: z.string(),
    signInUrl: z.string(),
    certificate: z.string(),
    enforcementType: ssoEnforcementTypeParser,
    externalUsersEnforcement: ssoExternalUserEnforcementParser,
    scim: z.object({
        directoryId: z.string(),
        apiKey: z.string(),
        baseUrl: z.string(),
    }),
    createdAt: dateParser(),
    updatedAt: dateParser(),
    // To be implemented
    provider: z.string().nullish(),
});
export class SsoConfigResponseDto extends createZodDto(SsoConfigResponseSchema) {
}
